import { jwtDecode } from 'jwt-decode';

function decodeToken<T>(token: string) {
  if (!token) {
    throw new Error('Token is required');
  }
  const value = jwtDecode<T>(token);
  if (!value) throw new Error('jwt_decode failed');
  return value;
}

export default decodeToken;
